<div class="row fields-group">
<div class="col">
    <label for="search-transformation-field" class="d-block list-title">{{ 'Format multiple inputs' | translate }}</label>
    <table class="over-colored-bg">
      <thead>
        <tr>
          <th class="text-center cell-order"></th>
          <th>{{ "Case transformation" | translate }}</th>
          <th>{{ "Separator" | translate }}</th>
        </tr>
      </thead>
      <tbody cdkDropList 
        [cdkDropListData]="fields"
        (cdkDropListDropped)="drop($event)">
        <tr cdkDrag *ngFor="let field of fields; let i = index; let last = last;">
          <td class="text-center align-middle handlers-cell">
            <i cdkDragHandle class="fas fa-arrows-alt handle mx-1" style="font-size:0.8rem"></i>
          </td>
          <td>
            <div class="w-100 d-flex">
              <span [ngClass]="{'text-uppercase': field.uppercase, 'text-lowercase': field.lowercase}" class="inner transition">{{field.name}}</span>
              <div class="btn-group-primary-light ml-auto">
                <button [ngClass]="{'active': field.uppercase}" (click)="uppercase(field)">
                  <i class="fad fa-font-case" style="--fa-secondary-opacity: 0.5;"></i>
                </button>
                <button [ngClass]="{'active': field.lowercase}" (click)="lowercase(field)">
                  <i class="fad fa-font-case" style="--fa-secondary-opacity: 1; --fa-primary-opacity: 0.5;"></i>
                </button>
              </div>
            </div>
          </td>
          <td>
              <input *ngIf="!last" type="text" [(ngModel)]="field.separator" class="form-control form-control-sm">
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
